import React from 'react';
import { IconProps } from '../types';

export const ProductVideosIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.6666 0.333374V8.44449L29.6666 8.44449V2.33337L23.5555 2.33337V0.333374L31.6666 0.333374ZM8.44436 0.333374H0.333252V8.44449H2.33325V2.33337H8.44436V0.333374ZM23.5555 31.6667H31.6666V23.5556L29.6666 23.5556V29.6667H23.5555V31.6667ZM0.333253 23.5556L0.333252 31.6667L8.44436 31.6667L8.44436 29.6667L2.33325 29.6667L2.33325 23.5556H0.333253ZM14.5555 7.66671H24.3332V13.3334H23.4166V24.1294H8.58325V13.3334H7.66658V7.66671H12.5554H14.5555ZM17.3888 13.3334H21.4166V22.1294H17.3888V13.3334ZM15.3888 13.3334H14.5555H12.5554H10.5833V22.1294H15.3888V13.3334ZM14.5555 9.66671H12.5554H9.66659V11.3334H12.5554H14.5555H22.3332V9.66671H14.5555Z"
            fill={color}
        />
    </svg>
);
